// mempool.space calls.
//
// All three endpoints send `Access-Control-Allow-Origin: *`, so they work from
// the browser with no key and no proxy - checked before this page was built,
// which is the bar every data source here has to clear. The site already talks
// to this host for the block tip on Bitcoin Live.
//
// Every call resolves to null on failure rather than throwing. The page renders
// whichever pieces arrived; a third-party outage should cost a card, not the
// route.

const API = "https://mempool.space/api";

const getJson = async (path, label) => {
  try {
    const response = await fetch(`${API}${path}`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error(`${label} fetch failed:`, error);
    return null;
  }
};

// { fastestFee, halfHourFee, hourFee, economyFee, minimumFee }, all sat/vB
export const getRecommendedFees = async () => {
  const fees = await getJson("/v1/fees/recommended", "Fee estimate");
  return Number.isFinite(fees?.fastestFee) ? fees : null;
};

// { count, vsize, total_fee } - vsize in vbytes, total_fee in sats
export const getMempoolStatus = async () => {
  const status = await getJson("/mempool", "Mempool status");
  return Number.isFinite(status?.count) ? status : null;
};

// The queue miners are actually looking at: what the next blocks would contain
// if they were mined right now, highest fee rate first.
export const getProjectedBlocks = async () => {
  const blocks = await getJson("/v1/fees/mempool-blocks", "Projected blocks");
  return Array.isArray(blocks) ? blocks : null;
};

// The most recent blocks, newest first, with the extras that make a block worth
// looking at: the pool that found it, its fee revenue and its transaction count.
export const getRecentBlocks = async () => {
  const blocks = await getJson("/v1/blocks", "Recent blocks");
  return Array.isArray(blocks) ? blocks : null;
};

// Every transaction id in a block.
//
// This is the only way to tell which of the transactions on screen a block
// confirmed. blockchain.info's websocket sends a `txIndexes` array on its block
// message, which looks like the cheaper answer, but the `tx_index` on its
// unconfirmed transactions is now always 0 - the field is deprecated and there
// is nothing to match against. Hashes are the only shared key left.
//
// The response is large, around 400KB for a full block, so callers should ask
// only when a new block has actually landed and there is something on screen to
// match it against.
export const getBlockTxids = async (hash) => {
  const txids = await getJson(`/block/${hash}/txids`, "Block transaction ids");
  return Array.isArray(txids) ? txids : null;
};
